export default __webpack_public_path__ + "static/Scroll-Image---Asphalt-Parking-Lot-Removal-4ac3cbc6947b61dd6830fe159b47cc07.jpg";